import script from "./BlogHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BlogHeader.vue?vue&type=style&index=0&id=491a9226&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-491a9226"]])

export default __exports__